export const ORDER_LOGS = `
query orderLogs(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: OrderLogOrderInput
  $filter: FilterOrderLogInput
  $supplier_id: Int
){
  orderLogs(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter
    supplier_id:$supplier_id
  ){
    __typename
    ...on OrderLog{
      id
      log_action{
        id
        name
        translation_key
      }
      order{
        id
        name
      }
      old_status_id
      old_order_status{
        id
        name
        translation_key
        hex_color
      }
      new_status_id
      new_order_status{
        id
        name
        translation_key
        hex_color
      }
      user{
        email
        contact {
          firstname
          lastname
        }        
      }
      description
      role_type
      its
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const ORDER_LOG_COUNT = `
query orderLogCount(
  $tenant_id: Int!,
  $filter: FilterOrderLogInput,
  $searchText: String,
  $supplier_id: Int
){
  orderLogCount(
    tenant_id:$tenant_id,
    filter:$filter,
    searchText:$searchText,
    supplier_id:$supplier_id
  ){
    __typename
    ...on Count{
      count      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
